module.exports = __webpack_public_path__ + "static/media/ladybug.64252b40.jpg";